// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"2facbeb3","70":"6cb0267e","71":"87959abf","195":"db8749ca","293":"d0a1d17f","349":"aad7b08a","360":"804374f8","419":"0b94cc9e","606":"20b5474f","621":"ed5729d0","870":"b7071988"}[chunkId] + ".chunk.css";
};